import { useState, useEffect } from 'react';
import './App.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import Main from './Pages/Main';
import Tours from './components/Tours';
import ViewTours from './components/ViewTours';
import UpdateTour from './components/UpdateTour';
import ManageCars from './components/ManageCars';
import Navbar from './components/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import AddCars from './components/AddCars';
import Login from './Pages/Login';

function App() {
  // State to track logged in status
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    // Check if the user is logged in by getting the value from sessionStorage
    const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    setLoggedIn(isLoggedIn);
  }, []);

  // PrivateRoute component to restrict access to routes based on login status
  function PrivateRoute({ element }) {
    if (!loggedIn) {
      // Redirect to login if the user is not logged in
      return <Navigate to="/login" />;
    }
    // If logged in, render the provided component
    return element;
  }

  return (
    <>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Main />} />
        {/* Protected Routes */}
        <Route exact path="/ManageTours" element={<PrivateRoute element={<ViewTours />} />} />
        <Route exact path="/Tours" element={<PrivateRoute element={<Tours />} />} />
        <Route exact path="/UpdateTours" element={<PrivateRoute element={<UpdateTour />} />} />
        <Route exact path="/ManageCars" element={<PrivateRoute element={<ManageCars />} />} />
        <Route exact path="/AddCars" element={<PrivateRoute element={<AddCars />} />} />
        
        <Route exact path="/login" element={<Login />} />
      </Routes>
    </>
  );
}

export default App;
